import React from 'react';
import { Link } from 'react-router-dom';
import { Logo } from '../brand/Logo';
import { Seal } from '../brand/Seal';
import { programs } from '../../data/programs';
import { products } from '../../data/products';
import { navItems } from '../../data/site';
export function Footer() {
  return <footer className="border-t border-ink/10 bg-cream-deep text-ink" data-id="element-140" data-mp="5nlwucfmly9y">
      <div className="mx-auto max-w-shell px-6 py-16 md:px-8 md:py-20" data-id="element-141" data-mp="5pf49ty2cmj0">
        <div className="grid gap-12 lg:grid-cols-[1.3fr_1fr_1fr_1fr_1fr]" data-id="element-142" data-mp="pkddqeafwxy">
          <div data-id="element-143" data-mp="3s1m2nj0uc1f2">
            <Logo className="text-lg" data-id="element-144" data-mp="3s13zs3joaoy6" />
            <p className="mt-6 max-w-xs font-serif text-2xl leading-snug text-ink" data-id="element-145" data-mp="3n3k9u6dm4nqe">
              More choice is better health for all.
            </p>
            <Seal className="mt-10 h-24 w-24 text-brick/60" data-id="element-146" data-mp="3j3a2apa69p9f" />
          </div>

          <FooterColumn title="Programs" data-id="element-147" data-mp="3e35o55wql6md">
            {programs.slice(0, 5).map(program => <FooterLink key={program.slug} to={`/programs/${program.slug}`} data-id="element-148" data-mp="393jaivczxod1">
                {program.name}
              </FooterLink>)}
          </FooterColumn>

          <FooterColumn title="Pharmacy" data-id="element-149" data-mp="2p3l0sfdqn5z7">
            {products.slice(0, 5).map(product => <FooterLink key={product.slug} to={`/shop/${product.slug}`} data-id="element-150" data-mp="2bcom7sgncpb5">
                {product.name}
              </FooterLink>)}
          </FooterColumn>

          <FooterColumn title="Republic" data-id="element-151" data-mp="2g9f1idkmngvi">
            {navItems.map(item => <FooterLink key={item.to} to={item.to} data-id="element-152" data-mp="341lrmuzrermh">
                {item.label}
              </FooterLink>)}
          </FooterColumn>

          <FooterColumn title="Patients" data-id="element-153" data-mp="2u369hhipmsp4">
            <FooterLink to="/get-started" data-id="element-154" data-mp="2u2efuc8ob51h">Start intake</FooterLink>
            <FooterLink to="/labs" data-id="element-155" data-mp="2z1hijq16kz6a">Book a lab draw</FooterLink>
            <FooterLink to="/pricing" data-id="element-156" data-mp="2z3u0w4aupbjv">Membership pricing</FooterLink>
            <FooterLink to="/about" data-id="element-157" data-mp="1im6a61xy3dll">Clinical standards</FooterLink>
          </FooterColumn>
        </div>

        <div className="rule-light mt-16 pt-8" data-id="element-158" data-mp="1nof1yuz309m4">
          <p className="max-w-4xl text-xs leading-relaxed text-ink-muted" data-id="element-159" data-mp="13khjxu5k6wr3">
            Republic is a direct-pay clinical practice. Treatment is prescribed only where clinically
            appropriate following review by a licensed clinician. Compounded medications are not
            FDA-approved products and are dispensed by US-licensed 503A and 503B pharmacies. This
            site is for informational purposes and is not a substitute for individual medical advice.
          </p>
          <div className="mt-8 flex flex-col gap-4 text-xs text-ink-muted sm:flex-row sm:items-center sm:justify-between" data-id="element-160" data-mp="fv56uj7424ji">
            <p data-id="element-161" data-mp="bsrzxrgmo0l5">© {new Date().getFullYear()} Republic Health, Inc.</p>
            <div className="flex gap-6" data-id="element-162" data-mp="6ugq3gqc1q2x">
              <Link to="/about" className="hover:text-brick" data-id="element-163" data-mp="6vicghcstyzy">
                Privacy
              </Link>
              <Link to="/about" className="hover:text-brick" data-id="element-164" data-mp="2669rdpk5lhlg">
                Terms
              </Link>
              <Link to="/about" className="hover:text-brick" data-id="element-165" data-mp="21915pezsqvfg">
                HIPAA notice
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>;
}
function FooterColumn({
  title,
  children
}: {
  title: string;
  children: React.ReactNode;
}) {
  return <div data-id="element-166" data-mp="2ij52ifxabzrj">
      <h2 className="text-[0.6875rem] uppercase tracking-label text-brick" data-id="element-167" data-mp="2iic545k7umm2">{title}</h2>
      <ul className="mt-6 flex flex-col gap-3" data-id="element-168" data-mp="2nflpv7wnua3k">{children}</ul>
    </div>;
}
function FooterLink({
  to,
  children
}: {
  to: string;
  children: React.ReactNode;
}) {
  return <li data-id="element-169" data-mp="1urpuq7mqoq8w">
      <Link to={to} className="text-sm text-ink-soft transition-colors duration-150 ease-republic hover:text-brick" data-id="element-170" data-mp="1urg5wndfkp4s">
        {children}
      </Link>
    </li>;
}